import React from 'react';
import PropTypes from 'prop-types';

import { Title } from '@nerdwallet/currency';

import styles from './miniHero.module.less';

const MiniHero = ({
  backgroundColor,
  backgroundImageUrl,
  color,
  copy,
  isDefault,
}) => {
  const heroBackgroundImage = {
    backgroundImage: `url(${backgroundImageUrl})`,
  };

  const heroBackgroundColor = {
    backgroundColor: `${backgroundColor}`,
  };

  const heroTextColor = {
    color: `${color}`,
  };

  const miniHeroOutput = !isDefault ? (
    <div className={styles.miniHeroFancy} style={heroBackgroundImage}>
      <div style={heroBackgroundColor} className={styles.miniHeroFancyContent}>
        <Title
          className={styles.heroTitle}
          style={heroTextColor}
          size="small"
          component="h2"
        >
          {copy}
        </Title>
      </div>
    </div>
  ) : (
    <div className={styles.miniHeroDefault} style={heroBackgroundImage}>
      <Title
        className={styles.heroTitle}
        style={heroTextColor}
        component="h2"
        size="small"
      >
        {copy}
      </Title>
    </div>
  );

  return <div>{miniHeroOutput}</div>;
};

MiniHero.propTypes = {
  backgroundColor: PropTypes.string,
  backgroundImageUrl: PropTypes.string,
  color: PropTypes.string,
  copy: PropTypes.string,
  isDefault: PropTypes.bool,
};

MiniHero.defaultProps = {
  backgroundColor: '#EEF7FF',
};

MiniHero.displayName = 'Mini Hero';

export default MiniHero;
